"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailGiven = exports.reasonGiven = exports.userEvents = void 0;
const USER_ACTION = 'user_action';
exports.userEvents = {
    CLICK_CANCEL_APPT: `${USER_ACTION}.click.cancel_appointment`,
    CLICK_SIDEBAR_PHONE: `${USER_ACTION}.click.phone_number_on_need_help`,
    CLICK_RESCHEDULE_CTA: `${USER_ACTION}.click.reschedule_cta`,
    CLICK_NEW_SEARCH_CTA: `${USER_ACTION}.click.new_search_cta`,
    APPT_CANCEL_FAIL: `${USER_ACTION}.error.appt_cancelation_fail`
};
exports.reasonGiven = 'reason_given';
exports.emailGiven = 'email_given';
//# sourceMappingURL=Tracking.js.map